import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import PageTitle from '../../common/page-title/index';
import InlineCKEditor from '../../common/editor/inline-editor';
import ContactForm from './contact-us-form-postlogin';
import { getNewContact } from '../../../actions/contacts';
import { loadPageContent } from '../../../actions/content';

import '../styles.css';

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.pageSlug = 'contact-us-post-login';
  }

  handleContentSaved = () => {
    const { dispatch } = this.props;
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getNewContact());
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    return (
      <Container fluid className="contact-us  user-inner-container">
        <Row>
          <Col lg={12} className="post-login-contact-title">
            <PageTitle>
              Contact us
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              contents={this.props.contents[`${this.pageSlug}_content_text`]}
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ContactForm
              enquiries={this.props.enquiries}
              outlets={this.props.outlets}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  enquiries: state.registration.contact.enquiries || [],
  outlets: state.registration.contact.outlets || [],
  contents: state.content.list
});

export default connect(mapStateToProps)(ContactUs);
